import React, { useEffect, useRef } from 'react';
import { collection, getDocs } from 'firebase/firestore';

function RentMap({ db }) {
  const mapRef = useRef(null);
  const googleMapRef = useRef(null);

  useEffect(() => {
    const loadMap = async () => {
      // Load Google Maps JavaScript API
      const google = window.google;
      if (!google) return;

      // Create map instance
      const map = new google.maps.Map(mapRef.current, {
        // Center on Williamsburg/Bushwick area
        center: { lat: 40.7053, lng: -73.9235 },
        zoom: 12,
        mapTypeId: 'roadmap'
      });
      googleMapRef.current = map;

      // Fetch rent data from Firestore
      const submissions = await getDocs(collection(db, 'submissions'));
      
      // Transform submissions into heatmap data points
      const heatmapData = submissions.docs
        .filter(doc => {
          const data = doc.data();
          return data.latitude && data.longitude && data.currentRent;
        })
        .map(doc => {
          const data = doc.data();
          return {
            location: new google.maps.LatLng(data.latitude, data.longitude),
            weight: parseFloat(data.currentRent) // Use rent amount as weight
          };
        });

      // Create and set up heatmap layer
      const heatmap = new google.maps.visualization.HeatmapLayer({
        data: heatmapData,
        map: map,
        radius: 50,
        gradient: [
          'rgba(0, 255, 255, 0)',
          'rgba(0, 255, 255, 1)',
          'rgba(0, 191, 255, 1)',
          'rgba(0, 127, 255, 1)',
          'rgba(0, 63, 255, 1)',
          'rgba(0, 0, 255, 1)',
          'rgba(0, 0, 223, 1)',
          'rgba(0, 0, 191, 1)',
          'rgba(0, 0, 159, 1)',
          'rgba(0, 0, 127, 1)',
          'rgba(63, 0, 91, 1)',
          'rgba(127, 0, 63, 1)',
          'rgba(191, 0, 31, 1)',
          'rgba(255, 0, 0, 1)'
        ]
      });
    };

    loadMap();
  }, [db]);

  return (
    <div 
      ref={mapRef} 
      style={{ width: '100%', height: '600px', borderRadius: '8px' }}
    />
  );
}

export default RentMap; 